import InfoIcon from '@material-design-icons/svg/filled/info.svg?react';
import { usePublisher } from '../hooks/usePublisher';
import {
  PUBLISHER_FROZEN_BANNER_MESSAGE,
  PUBLISHER_FROZEN_SUPPORT_TOOLTIP,
} from '../utils/publisherFreeze';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './ui/tooltip';

export function PublisherFrozenBanner() {
  const { activePublisher } = usePublisher();

  if (activePublisher?.isFrozen !== true) {
    return null;
  }

  return (
    <div className="flex h-8 shrink-0 items-center justify-center gap-2 border-b border-red-500/20 bg-red-950/35 px-4 text-xs font-medium text-red-100">
      <span className="truncate">{PUBLISHER_FROZEN_BANNER_MESSAGE}</span>
      <TooltipProvider delayDuration={100}>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type="button"
              aria-label="Publisher freeze support information"
              className="inline-flex size-5 items-center justify-center rounded-full text-red-200 hover:text-white focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-red-300"
            >
              <InfoIcon className="size-4 fill-current" />
            </button>
          </TooltipTrigger>
          <TooltipContent>
            <p>{PUBLISHER_FROZEN_SUPPORT_TOOLTIP}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
